var exports = {
  "X$": "x93eb46d8--a97488--pagination",
  "x6": "x93eb46d8--a97488--button",
  "Pf": "x93eb46d8--a97488--label",
  "St": "x93eb46d8--a97488--slash",
};

module.exports = exports;
